import { AxiosResponse } from 'axios';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

type SpeakerType = {
  about: string;
  companyName: string;
  createdAt: string;
  id: string;
  jobTitle: string;
  name: string;
  picture: string;
  updatedAt: string;
};

export type SeminarContentType = {
  createdAt: string;
  description: string;
  id: string;
  name: string;
  speaker: SpeakerType;
  speakerId: string;
  thumbnail: string;
  type: string;
  updatedAt: string;
  url: string;
};

function mapCourseToSeminar(row: any): SeminarContentType {
  const sp = row.speaker ?? {};
  return {
    id: row.id,
    name: row.name,
    description: row.description,
    thumbnail: row.thumbnail,
    type: row.type,
    url: row.url,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
    speakerId: row.speaker_id || '',
    speaker: {
      id: sp.id || '',
      name: sp.name || '',
      companyName: sp.company_name || '',
      jobTitle: sp.job_title || '',
      about: sp.about || '',
      picture: sp.picture || '',
      createdAt: sp.created_at || '',
      updatedAt: sp.updated_at || '',
    },
  };
}

const getAllSeminars = async (): Promise<AxiosResponse<SeminarContentType[]>> => {
  const { data, error } = await supabase
    .from('academy_contents')
    .select('*, speaker:academy_speakers(*)')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return asResponse((data || []).map(mapCourseToSeminar));
};

const getSeminarById = async (id: string): Promise<AxiosResponse<SeminarContentType>> => {
  const { data, error } = await supabase
    .from('academy_contents')
    .select('*, speaker:academy_speakers(*)')
    .eq('id', id)
    .single();

  if (error) throw error;
  return asResponse(mapCourseToSeminar(data));
};

export default {
  getAllSeminars,
  getSeminarById,
};
